import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';

import { AuthContext } from '~contexts/auth';
import { UserContext } from '~contexts/user';
import { useListingRedirect } from '~hooks/useListingRedirect';

import Button from '~components/button';
import HeroHp from '~components/hero-hp';

const Header = () => {
  const intl = useIntl();
  const { isAuthenticated } = useContext(AuthContext);
  const { user } = useContext(UserContext);

  const listingRedirect = useListingRedirect();

  return (
    <HeroHp.Wrapper>
      {/* <HeroHp.Subtitle>
        {intl.formatMessage(
          {
            id: 'containers.homepage.seo.hero.subtitle',
            defaultMessage: 'Your house help is waiting',
          }
        )}
      </HeroHp.Subtitle> */}
      <HeroHp.Title>
        {intl.formatMessage({
          id: 'containers.homepage.seo.hero.title',
          defaultMessage: 'Find a great cleaner or client without hassle',
        })}
      </HeroHp.Title>
      {/* <HeroHp.Intro>
        {intl.formatMessage({
          id: 'containers.homepage.seo.hero.intro',
          defaultMessage:
            'Experience the convenience of domestic help. Get not only domestic help according to your wishes, but also the guarantee that you will remain satisfied!',
        })}
      </HeroHp.Intro> */}
      {!isAuthenticated || !user || !user.accountType ? (
        <HeroHp.Buttons>
          <Link to="/intake/client">
            <Button className="c-btn c-btn--text bg-lime-green">
              {intl.formatMessage({
                id: 'containers.homepage.seo.hero.buttons.cleaner',
                defaultMessage: "I'm looking for a cleaner",
              })}
            </Button>
          </Link>
          <Link to="/intake/worker">
            <Button className="c-btn c-hp-btn-border c-btn--text largeee">
              {intl.formatMessage({
                id: 'containers.homepage.seo.hero.buttons.clients',
                defaultMessage: "I'm looking for a client",
              })}
            </Button>
          </Link>
        </HeroHp.Buttons>
      ) : (
        <HeroHp.Buttons>
          <Link to={listingRedirect}>
            <Button>
              {intl.formatMessage({
                id: `containers.homepage.hero.buttons.overview.${user.accountType}`,
                defaultMessage: 'Go to overview',
              })}
            </Button>
          </Link>
        </HeroHp.Buttons>
      )}
    </HeroHp.Wrapper>
  );
};

export default Header;
